import React, { Component } from 'react'
import { Header, PageWrapper } from '../components'

class OurTeam extends Component {
  state = {}
  render() {
    return (
      <React.Fragment>
        <Header
          title={'Our Team'}
          icon="arrowBack"
          onClickBack={() => this.props.history.replace('/user-profile')}
          color="#fff"
        />
        <PageWrapper viewPadding="76px 16px 88px" />
      </React.Fragment>
    )
  }
}

export default OurTeam



// WEBPACK FOOTER //
// ./src/pages/OurTeam.js